export enum Domains {
	Default = 'default',
	Home = 'home',
	Help = 'help',
	PDP = 'pdp',
	PLP = 'plp',
	Labels = 'labels',
	FeatureFlag = 'featureFlag',
	CountryConfiguration = 'countryConfiguration',
	Link = 'link',
	Payments = 'payments',
	Legal = 'legal',
	Product = 'product',
	Search = 'search',
	AnalyticsReader = 'analyticsReader',
	GiftVoucher = 'giftVoucher',
}
